import React from 'react';
import NumberFormat from 'react-number-format';

// Input de moneda estilo "cajero": el valor interno se maneja en centavos y
// cada dígito tecleado entra por la derecha ($0.00 -> $0.05 -> $0.50 -> $5.00).
// Se usa el mismo `format` tanto en modo lectura como en modo edición.
export default function CurrencyFormatInput(props) {

    const { value, className, disabled, displayType, onValueChange } = props;

    const currencyFormat = (cents) => {
        if (!Number(cents)) return '$0.00';

        return new Intl.NumberFormat('es-MX', {
            style: "currency",
            currency: "MXN",
            minimumFractionDigits: 2
        }).format(parseFloat(cents / 100));
    }

    const isAllowed = ({ formattedValue, floatValue }) => {
        return formattedValue === "" || floatValue / 100 <= 10000000000;
    }

    // Math.round evita errores de punto flotante (0.29 * 100 = 28.999999999999996)
    const cents = !value || !Number(value) ? 0 : Math.round(Number(value) * 100);

    return (
        <NumberFormat
            value={cents}
            className={className}
            disabled={disabled}
            displayType={displayType}
            allowNegative={false}
            isAllowed={isAllowed}
            format={currencyFormat}
            onValueChange={onValueChange ? (values) => onValueChange((+values.value / 100).toFixed(2)) : undefined}
        />)
}
